import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import ReduxToastr from 'react-redux-toastr';
import ReactGA from "react-ga";

import store from './client/js/store/store';
import routes from "./client/js/router/AppRoutes";
import HeadParams from './client/js/component/common/HeadParams';
import AnalyticsListener from "./analytics/AnalyticsListener";

//* Enables Google Analytics just for the PROD server
// const trackingId = config.GAtrackingId;
const trackingId = process.env.NODE_ENV === 'production' && process.env.REACT_APP_GAtrackingId
if (trackingId) {
    ReactGA.initialize(trackingId);
}

const App = () => {
    return (
        <Provider store={store}>
            <div>
                <HeadParams />
                <BrowserRouter>
                    {trackingId && <AnalyticsListener />}
                    {routes}
                </BrowserRouter>
                <ReduxToastr
                    timeOut={5000}
                    newestOnTop={false}
                    preventDuplicates
                    position="top-right"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                />
            </div>
        </Provider>
    )
}

export default App;
